module.exports = __webpack_public_path__ + "static/media/empty-inex.9b0d87f9.svg";